__turbopack_context__.v({
  "description": "styles-module-scss-module__WNBljq__description",
  "full-tape": "styles-module-scss-module__WNBljq__full-tape",
  "grayscale": "styles-module-scss-module__WNBljq__grayscale",
  "mobile-title-number-container": "styles-module-scss-module__WNBljq__mobile-title-number-container",
  "not-mobile": "styles-module-scss-module__WNBljq__not-mobile",
  "pic-and-tape-container": "styles-module-scss-module__WNBljq__pic-and-tape-container",
  "pic-and-tape-container-outer": "styles-module-scss-module__WNBljq__pic-and-tape-container-outer",
  "picture-container": "styles-module-scss-module__WNBljq__picture-container",
  "tape-background-container": "styles-module-scss-module__WNBljq__tape-background-container",
  "tape-container": "styles-module-scss-module__WNBljq__tape-container",
  "tape-number": "styles-module-scss-module__WNBljq__tape-number",
  "tape-number-mobile": "styles-module-scss-module__WNBljq__tape-number-mobile",
  "tape-title-number-mobile": "styles-module-scss-module__WNBljq__tape-title-number-mobile",
  "title": "styles-module-scss-module__WNBljq__title",
  "title-description-container": "styles-module-scss-module__WNBljq__title-description-container",
  "title-mobile": "styles-module-scss-module__WNBljq__title-mobile",
});
